// extracted by mini-css-extract-plugin
export var circle = "_2r-2";
export var icon = "_2r-a";
export var iconHighlight = "_2r-0";
export var lg = "_2r-8";
export var md = "_2r-7";
export var outline = "_2r-4";
export var sm = "_2r-6";
export var square = "_2r-1";
export var xl = "_2r-9";
export var xs = "_2r-5";
export var xxs = "_2r-3";